<template>
  <button
    :class="[
      'burger',
      $store.state.isMenuOpen ? 'burger--close' : '',
    ]"
  >
    <span class="burger__line" />
    <span class="burger__line" />
    <span class="burger__line" />
    <span class="burger__line" />
  </button>
</template>

<script>
export default {
  name: 'NavigatorBurger',
};
</script>

<style lang="scss" scoped>
.burger {
  width: 30px;
  height: 25px;

  border: 0;
  background-color: transparent;
  transition: transform 0.5s $outCirc;

  display: flex;
  align-items: stretch;
  justify-content: space-between;
  flex-flow: column nowrap;

  cursor: pointer;

  &__line {
    display: block;
    width: 100%;
    height: 2px;

    background-color: var(--color-headline-dark);
    transition: transform 0.5s $outCirc;
    transform: scaleX(1);

    &:last-child {
      transform-origin: 100% 50%;
    }

    &:first-child,
    &:last-child {
      transform: scaleX(0.2);
    }

    &:first-child,
    &:nth-child(2),
    &:nth-child(3) {
      transform-origin: 0% 50%;
    }
  }

  &.burger--close {
    .burger__line {
      &:first-child,
      &:last-child {
        transform: scaleX(0);
      }

      &:nth-child(2) {
        transform: rotateZ(45deg) translateY(-10px);
      }

      &:nth-child(3) {
        transform: rotateZ(-45deg) translateY(10px);
      }
    }
  }
}
</style>
